// Reviews
const press = document.querySelector('.press');

if (press) {
  const pressSlider = new Swiper('.press', {
    draggable: true,
    grabCursor: true,
    pagination: {
      el: '.press__pagination',
      type: 'bullets',
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.review-button-next',
      prevEl: '.review-button-prev',
    },
    slidesPerView: 1,
  });
}
